"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMenuNoteMutationOptions = exports.createMenuNoteMutation = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const menuPlanner_1 = require("../queries/menuPlanner");
exports.createMenuNoteMutation = client_1.gql `
  mutation CreateMenuNote($input: MenuNoteInput!) {
    createMenuNote(input: $input) {
      id
      text
      menuSectionId
      date
    }
  }
`;
exports.createMenuNoteMutationOptions = (variables, menuPlannerQueryVariables) => {
    return {
        variables,
        optimisticResponse: {
            __typename: "Mutation",
            createMenuNote: Object.assign(Object.assign({}, variables.input), { id: "-1", __typename: "MenuNote" }),
        },
        update: !menuPlannerQueryVariables
            ? undefined
            : (store, { data: dataResponse }) => {
                if (!dataResponse) {
                    return;
                }
                const { createMenuNote } = dataResponse;
                updateQuery_1.updateQuery(store, menuPlanner_1.menuPlannerQuery, x => {
                    x.menuPlanner.push(createMenuNote);
                }, menuPlannerQueryVariables);
            },
    };
};
//# sourceMappingURL=createMenuNote.js.map